// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"445":"84aa0318","588":"5329a0f4"}[chunkId] + ".chunk.css";
};